import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { config } from "../../../config";
import { elms } from "../../vars/elms";
import { params } from "../../vars/params";

gsap.registerPlugin(ScrollTrigger);

export const header = (): void => {
  if (!elms.header) return;

  const checkHeaderHiding = () => {
    console.log(window.scrollY);
    if (!elms.header) return;
    const headerHidingPoint = params.isSp ? config.headerHidingPointSp : config.headerHidingPoint;
    const headerOffsetTop = window.scrollY;
    console.log(headerHidingPoint, -headerOffsetTop);
    if (headerHidingPoint < headerOffsetTop) {
      if (params.scrollDirection === "down") {
        elms.header.classList.add("is-hidden");
        elms.header.classList.remove("is-ham-open");
      } else {
        elms.header.classList.remove("is-hidden");
      }
    } else {
      elms.header.classList.remove("is-hidden");
    }
  };
  window.addEventListener("scroll", checkHeaderHiding);
};
